import React, { useState, useRef } from 'react';
import { Badge, IconButton, Popover, Box, Typography, Tooltip } from '@mui/material';
import NotificationsIcon from '@mui/icons-material/Notifications';
import { useNotifications } from '../contexts/NotificationContext';
import NotificationPanel from './NotificationPanel';

const NotificationBell: React.FC = () => {
  const { unreadCount, isLoading } = useNotifications();
  const [anchorEl, setAnchorEl] = useState<HTMLButtonElement | null>(null);
  const buttonRef = useRef<HTMLButtonElement>(null);

  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const open = Boolean(anchorEl);

  return (
    <>
      <Tooltip title={unreadCount > 0 ? `${unreadCount} unread notification${unreadCount > 1 ? 's' : ''}` : 'No new notifications'}>
        <IconButton
          ref={buttonRef}
          onClick={handleClick}
          aria-label="notifications"
          sx={{ position: 'relative', color: '#533B7D' }}
        >
          <Badge 
            badgeContent={unreadCount > 0 ? unreadCount : 0} 
            color="error"
            max={99}
            invisible={unreadCount === 0}
            sx={{
              '& .MuiBadge-badge': {
                right: 4,
                top: 4,
                minWidth: '18px',
                height: '18px',
                fontSize: '0.75rem',
                fontWeight: 'bold',
              }
            }}
          >
            <NotificationsIcon sx={{ color: '#533B7D' }} />
          </Badge>
        </IconButton>
      </Tooltip>
      <Popover
        open={open}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'right',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'right',
        }}
        PaperProps={{
          sx: {
            width: 400,
            maxWidth: '90vw',
            maxHeight: '80vh',
            mt: 1
          }
        }}
      >
        <NotificationPanel onClose={handleClose} />
      </Popover>
    </>
  );
};

export default NotificationBell;
